"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconWrapper = exports.Wrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.Wrapper = styled_components_1.default.a `
  display: block;
  text-decoration: none;
  color: #c8cdd8;
  width: 100%;
  & > img {
    width: 100%;
  }

  & > svg {
    width: 100%;
  }
`;
exports.IconWrapper = styled_components_1.default.div `
  ${({ theme, height, width }) => (0, styled_components_1.css) `
    max-width: 200px;
    max-height: 60px;

    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
    padding: 0 ${theme.spacing.unit}px;
    background: linear-gradient(
      -180deg,
      rgb(251, 251, 251) 0%,
      rgb(239, 239, 239) 100%
    );
    border-radius: ${theme.border.radius.medium * 2}px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: ${theme.shadows.boxShadow.downloadIcon};
    font-size: 16px !important;

    & img,
    & svg {
      height: 80%;
      width: auto;
      min-height: 24px;
      min-width: 24px;
      margin-right: 8px;
    }

    & span {
      color: rgb(45, 50, 59);
      font-weight: bold;
      letter-spacing: 0px;
    }

    ${height &&
    (0, styled_components_1.css) `
      height: ${height};
    `}
    ${width &&
    (0, styled_components_1.css) `
      width: ${width};
    `}
  `}
`;
//# sourceMappingURL=styled.js.map